import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Chip from "@mui/material/Chip";
import MenuList from "@mui/material/MenuList";
import { Link, useListContext } from "react-admin";
import CustomMenuItemLink from "../unit/CustomMenuItemLink";
import HmSubHeaderTitle from "../unit/HmSubHeaderTitle";
import { Typography } from "@mui/material";
import { hmLightTheme } from "../themes/hmTheme";
import formatTitleText from "../unit/formatTitleText";
const AppMenuTitle = ({ ...props }) => {
  let type = props.type;
  const appCounts = props.count;

  let bubbleBgColor = "rgba(0, 0, 0, 0.08)";
  let bubbleColor = "rgba(0, 0, 0, 0.87)";
  if (appCounts == 0) {
    bubbleBgColor = "rgba(0, 0, 0, 0.08)";
    bubbleColor = "rgba(0, 0, 0, 0.87)";
  } else {
    if (
      type == "New" ||
      type == "Initial Review" ||
      type == "Ready for Processing" ||
      type == "Ready for Screening" ||
      type == "Ready for Initial Review" ||
      type == "Ready for Final Review" ||
      type == "Ready for Notification" ||
      type == "Final Review" ||
      type == "Notification" ||
      type == "Countered" ||
      type == "Pre-Approved" ||
      type == "pre-approve" ||
      type == "Approved" ||
      type == "Ready for Review" ||
      type == "Offer Accepted" ||
      type == "Ready for Final Approval" ||
      type == "Closing Completed" ||
      type == "Ready for Disbursement"
    ) {
      // bubbleBgColor = "red";
      bubbleBgColor = "primary.main";
      bubbleColor = "white";
    } else if (
      type == "Acceptance Pending" ||
      type == "Pending Acceptance" ||
      type == "Closing Incomplete" ||
      type == "Verification Pending" ||
      type == "Pending Verification" ||
      type == "Hold" ||
      type == "On Hold" ||
      type == "Closing Pending" ||
      type == "Pending Closing"
    ) {
      bubbleBgColor = "#fff1da";
    } else if (type == "Expired" || type == "Declined") {
      bubbleBgColor = "#d32f2f";
      bubbleColor = "white";
    }
  }
  if (type == "Declined") {
    type = "Declined (Last 90 Days)";
  }
  if (type == "Voided") {
    type = "Voided (Last 90 Days)";
  }
  if (type == "Expired") {
    type = "Expired";
  }
  if (type == "Incomplete") {
    type = "Incomplete (Last 30 Days)";
  }
  if (type == "Hold" || type == "On Hold") {
    type = "On Hold (Last 90 Days)";
  }

  return (
    <span className="capitalize-first menu-text">
      {type}
      <Chip
        component="span"
        label={appCounts}
        size="small"
        sx={{
          ml: 1,
          float: "right",
          color: bubbleColor,
          backgroundColor: bubbleBgColor,
        }}
        className="numericText"
      />
    </span>
  );
};

const ApplicationAside = ({ ...props }) => {
  const { filterValues, isPending, isLoading } = useListContext();
  if (isPending || isLoading) return null;
  const status = filterValues.status;
  const subStatus = filterValues?.subStatus;
  const borrowerAgreement = filterValues?.borrowerAgreement;
  const totalData = props.totalData;

  return (
    <>
      <HmSubHeaderTitle
        title="Applications"
        sx={{
          display: "block",
          position: "absolute",
          top: "65px",
          left: "75px",
        }}
      />
      <Card className="hm-list-aside">
        <CardContent>
          <MenuList component="div" id="list-application-menus">
            <Typography
              variant="h3"
              className="hm-subtitle"
              sx={{
                pl: 0,
                pt: 1,
                pb: 1,
                mb: 1,
              }}
            >
              Under Review
            </Typography>
            <CustomMenuItemLink
              to='/applications?filter={"status":"New","subStatus":"Verification Pending"}'
              onClick={() => {
                props.onChange("New", "Verification Pending");
              }}
              state={{ _scrollToTop: true }}
              primaryText={
                <AppMenuTitle
                  type="Pending Verification"
                  count={totalData.newPendingverify}
                />
              }
              tooltipProps={{ title: "Pending Verification", children: <></> }}
              selected={
                status === "New" && subStatus == "Verification Pending"
                  ? true
                  : false
              }
            />
            <CustomMenuItemLink
              to='/applications?filter={"status":"New","subStatus":"Ready for Review"}'
              onClick={() => {
                props.onChange("New", "Ready for Review");
              }}
              state={{ _scrollToTop: true }}
              primaryText={
                <AppMenuTitle
                  type="Ready for Screening"
                  count={totalData.newReady}
                />
              }
              tooltipProps={{ title: "Ready for processing", children: <></> }}
              selected={
                status === "New" && subStatus == "Ready for Review"
                  ? true
                  : false
              }
            />
            <CustomMenuItemLink
              to='/applications?filter={"status":"Initial Review"}'
              onClick={() => {
                props.onChange("Initial Review", "");
              }}
              state={{ _scrollToTop: true }}
              primaryText={
                <AppMenuTitle
                  type="Ready for Initial Review"
                  count={totalData.initial}
                />
              }
              tooltipProps={{
                title: "Ready for initial review",
                children: <></>,
              }}
              selected={status === "Initial Review" ? true : false}
            />
            <CustomMenuItemLink
              to='/applications?filter={"status":"Final Review"}'
              onClick={() => {
                props.onChange("Final Review", "");
              }}
              state={{ _scrollToTop: true }}
              primaryText={
                <AppMenuTitle
                  type="Ready for Final Review"
                  count={totalData.final}
                />
              }
              tooltipProps={{
                title: "Ready for final review",
                children: <></>,
              }}
              selected={status === "Final Review" ? true : false}
            />

            <CustomMenuItemLink
              to='/applications?filter={"status":"To Notify"}'
              onClick={() => {
                props.onChange("To Notify", "");
              }}
              state={{ _scrollToTop: true }}
              primaryText={
                <AppMenuTitle
                  type="Ready for Notification"
                  count={totalData.notify}
                />
              }
              tooltipProps={{
                title: "Ready for notification",
                children: <></>,
              }}
              selected={status === "To Notify" ? true : false}
            />
            <hr />
            <Typography
              variant="h3"
              sx={{
                pl: 0,
                pt: 1,
                pb: 1,
                fontWeight: "bold",
                mb: 1,
                color: "#000",
              }}
            >
              Countered and Pre-Approved
            </Typography>
            <CustomMenuItemLink
              to='/applications?filter={"status":"CounteredAndPreApproved", "subStatus":"Acceptance Pending"}'
              onClick={() => {
                props.onChange("CounteredAndPreApproved", "Acceptance Pending");
              }}
              state={{ _scrollToTop: true }}
              primaryText={
                <AppMenuTitle
                  type="Pending Acceptance"
                  count={totalData.counteredPreApprovedNotAccept}
                />
              }
              tooltipProps={{
                title: "Pending Acceptance",
                children: <></>,
              }}
              selected={
                status == "CounteredAndPreApproved" &&
                subStatus == "Acceptance Pending"
                  ? true
                  : false
              }
            />
            <CustomMenuItemLink
              to='/applications?filter={"status":"CounteredAndPreApproved","subStatus":"Offer Accepted"}'
              onClick={() => {
                props.onChange("CounteredAndPreApproved", "Offer Accepted");
              }}
              state={{ _scrollToTop: true }}
              primaryText={
                <AppMenuTitle
                  type="Ready for Final Approval"
                  count={totalData.counteredPreApprovedAccept}
                />
              }
              tooltipProps={{
                title: "Ready for Final Approval",
                children: <></>,
              }}
              selected={
                status == "CounteredAndPreApproved" &&
                subStatus == "Offer Accepted"
                  ? true
                  : false
              }
            />
            <hr />
            <Typography
              variant="h3"
              sx={{
                pl: 0,
                pt: 1,
                pb: 1,
                fontWeight: "bold",
                mb: 1,
                color: "#000",
              }}
            >
              Approved
            </Typography>

            <CustomMenuItemLink
              to='/applications?filter={"status":"Approved","subStatus":"Pending Signature"}'
              onClick={() => {
                props.onChange("Approved", "Pending Signature");
              }}
              state={{ _scrollToTop: true }}
              primaryText={
                <AppMenuTitle
                  type="Pending Closing"
                  count={totalData.approveNotClosing}
                />
              }
              tooltipProps={{
                title: "Pending Closing",
                children: <></>,
              }}
              selected={
                status === "Approved" && subStatus === "Pending Signature"
                  ? true
                  : false
              }
            />
            <CustomMenuItemLink
              to='/applications?filter={"status":"Approved","subStatus":"Signature Completed"}'
              onClick={() => {
                props.onChange("Approved", "Signature Completed");
              }}
              state={{ _scrollToTop: true }}
              primaryText={
                <AppMenuTitle
                  type="Ready for Disbursement"
                  count={totalData.approveClosing}
                />
              }
              tooltipProps={{
                title: "Ready for disbursement",
                children: <></>,
              }}
              selected={
                status === "Approved" && subStatus === "Signature Completed"
                  ? true
                  : false
              }
            />
            <hr />
            <Typography
              variant="h3"
              sx={{
                pl: 0,
                pt: 1,
                pb: 1,
                fontWeight: "bold",
                mb: 1,
                color: "#000",
              }}
            >
              Not Under Review
            </Typography>
            <CustomMenuItemLink
              to='/applications?filter={"status":"Hold"}'
              onClick={() => {
                props.onChange("Hold", "");
              }}
              state={{ _scrollToTop: true }}
              primaryText={
                <AppMenuTitle type="On Hold" count={totalData.hold} />
              }
              tooltipProps={{ title: "On Hold", children: <></> }}
              selected={status === "Hold" ? true : false}
            />
            <hr className="thinner" />
            <CustomMenuItemLink
              to='/applications?filter={"status":"Expired"}'
              onClick={() => {
                props.onChange("Expired", "");
              }}
              state={{ _scrollToTop: true }}
              primaryText={
                <AppMenuTitle type="Expired" count={totalData.expired} />
              }
              tooltipProps={{ title: "Expired", children: <></> }}
              selected={status === "Expired" ? true : false}
            />
            <hr className="thinner" />
            <CustomMenuItemLink
              to='/applications?filter={"status":"Declined"}'
              onClick={() => {
                props.onChange("Declined", "");
              }}
              state={{ _scrollToTop: true }}
              primaryText={
                <AppMenuTitle type="Declined" count={totalData.decline} />
              }
              tooltipProps={{ title: "Declined", children: <></> }}
              selected={
                status === "Declined" && subStatus !== "voided" ? true : false
              }
            />
            <CustomMenuItemLink
              to='/applications?filter={"status":"Declined","subStatus":"voided"}'
              onClick={() => {
                props.onChange("Declined", "Voided");
              }}
              state={{ _scrollToTop: true }}
              primaryText={
                <AppMenuTitle type="Voided" count={totalData.voided} />
              }
              tooltipProps={{ title: "Voided", children: <></> }}
              selected={
                status === "Declined" && subStatus === "voided" ? true : false
              }
            />
            <hr className="thinner" />
            <CustomMenuItemLink
              to='/applications?filter={"status":"Incomplete"}'
              onClick={() => {
                props.onChange("Incomplete", "");
              }}
              state={{ _scrollToTop: true }}
              primaryText={
                <AppMenuTitle type="Incomplete" count={totalData.incomplete} />
              }
              tooltipProps={{ title: "Incomplete", children: <></> }}
              selected={status === "Incomplete" ? true : false}
            />
            <hr />
            <CustomMenuItemLink
              to={`/reports?filter={"status":"Inception to Date","reportType":"applications"}`}
              state={{ _scrollToTop: true }}
              primaryText={"Download More Application Data"}
              sx={{ "& .MuiTypography-root": { color: "#1976d2" } }}
            />
          </MenuList>
        </CardContent>
      </Card>
    </>
  );
};

export default ApplicationAside;
